export const en = {
    phone_number: "Phone number",
    pickup: "Pickup",
    required: "Required",
    invalid_phone_number: "Enter valid phone number",
    banned_phone_number:
        "Orders are not allowed for this phone number. Please contact support if you believe this is an error.",
    public_link_depleted: "This link has reached its usage limit. No more orders are available.",
    public_link_not_found: "This public order link is not valid.",
    public_order_link_price_exceeded:
        "The price for this ride exceeds the maximum allowed for this link.",
    geolocation_failed: "Unable to get your current location. Please enter your address manually.",
    geolocation_permission_denied_title: "Location access blocked",
    geolocation_permission_denied_message:
        "To use your current location, please enable location access in your browser settings.",
    geolocation_permission_denied_button: "Got it",
    CZK: "CZK",
    EUR: "€",
    on_board: "On board",
    soon: "soon",
    in_min_plural: "in {count} {count, plural, =0 {min} one {min} few {mins} other {mins}}",
    driver_not_found: "Driver not found",
    cancel_ride: "Cancel the ride",
    canceling: "Cancelling…",
    cancel_failed: "Cancel failed",
    ride_cancelled: "Ride cancelled",
    price_not_found: "Price not found, please try again.",
    name: "Name",
    destination: "Destination",
    pickup_time_15_min: "15 min",
    generic_error: "Something went wrong. Please try again later.",
    pay: "Pay",
    payment_failed: "Payment failed",
    search: "Search…",
    delete: "Delete",
    payment_card_bullet_1: "Automatic payment after each ride",
    payment_card_bullet_2: "Summary invoice at the end of the month",
    monthly_payment_bullet_1: "Monthly payment via bank transfer",
    monthly_payment_bullet_2: "Summary invoice at the end of the month",
    close: "Close",
    registration_legal_info:
        "By continuing you agree with <terms>General Business Terms and Conditions</terms>. Personal data will be processed for the purpose stated in <policy>Privacy Policy</policy>",
    terms_url: "https://www.liftago.cz/en/terms-and-conditions",
    policy_url: "https://www.liftago.cz/en/privacy-policy",
    back: "Back",
    rate_the_ride: "Rate the ride",
    // kiosk
    order_confirmed: "Your order is confirmed",
    sms_details:
        "You will soon receive an SMS with your driver's details and arrival time. If not, contact reception.",
    cancel_booking: "To cancel your booking, call the driver or reception.",
    get_taxi: "Get taxi",
    no_destination_found: 'No destination found for "{search}"',
    search_for_destination: "Search for address or place",
    enter_contact_details: "Enter your contact details",
    pickup_in: "Pickup in",
    dropoff_by: "Dropoff by",
    price: "Price",
    price_with_promo: "Price with promo",
    confirm_order: "Confirm order",
    visa_mastercard: "Visa, Mastercard",
    pay_to_driver: "Pay to driver",
    cash_or_card: "Cash or card",
    payment_covered: "Payment for the ride is covered by your host. Don't pay to driver.",
    kiosk_order_failed: "The order failed. Please ask the staff for assistance or try again.",
    reviews: "reviews",
    enter_pickup: "Enter pickup location",
    enter_destination: "Enter destination",
    order_taxi_without_registration: "Order taxi without registration",
    location_input_placeholder_pickup: "Pickup address",
    location_input_placeholder_dropoff: "Destination address",
    enter_route: "Enter route",
    ride_finished: "Ride finished",
    order_cancelled: "Order cancelled",
    driver_cancelled: "Driver cancelled the ride",
    driver_is_arriving: "Driver is arriving {when}",
    driver_is_waiting: "Driver is waiting",
    order_not_found: "Order not found",
    searching_driver: "Searching for driver",
    search_longer_than_usual: "Takes longer than usual, please be patient.",
    search_usual_time: "Usually takes about 15 seconds",
    refund_shortly: "We'll refund you shortly.",
    email_support: "Email us at service@liftago.com if anything did go wrong.",
    you_can_order_again: "Feel free to order again.",
    please_order_again: "Please order again",
    no_drivers_available:
        "We're sorry, but we weren't able to find any available drivers at the moment.",
    new_order: "New order",
    order_again: "Order again",
    driver_location_phone: "Show driver location and phone",
    set_pickup_here: "Pickup here",
    set_destination_here: "Destination here",
    pay_by_card: "Pay by card",
    no_drivers_around:
        "Unfortunately, there are no drivers in your area right now. Please try again later.",
    not_viable_route: "The ride is too short. Please choose a more distant destination.",
    are_you_sure_to_cancel_ride: "Do you really want to cancel?",
    public_order_brand_title: "Liftago: Travel safely",
    public_order_brand_reviews: "({count}K reviews)",
    public_order_brand_trust_indicator_quality_cars: "Quality cars",
    public_order_brand_trust_indicator_verified_drivers: "Verified drivers",
} as const;
